module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGf572066d2c45e535a99cf96eeb83de71.f572066d.png";